<script>
import {
	updateVoucher,
	getVoucherByCode,
} from "../../../api/services/voucher.service";
export default {
	props: {
		visible: Boolean,
		closeable: Boolean,
		voucherValid: Boolean,
		voucherStatus: String,
	},
	data() {
		return {
			isVoucherValid: false,
			voucherCurrentStatus: null,
			voucherCodeToUpdate: null,
			voucherCodeMissing: false,
			showVoucherUpdateSuccess: false,
			showVoucherUpdateFailed: false,
			showVocherCodeNotValid: false,
		};
	},
	computed: {
		showModal: {
			get() {
				return this.visible;
			},
			set(value) {
				if (!value) {
					this.$emit("close");
				}
			},
		},
	},
	mounted() {
		this.isVoucherValid = this.voucherValid;
		this.voucherCurrentStatus = this.voucherStatus;
	},
	methods: {
		async clickUpdateVoucherStatus() {
			if (this.voucherCodeToUpdate) {
				this.voucherCodeMissing = false;
				let getVoucher = await getVoucherByCode(this.voucherCodeToUpdate);

				if (getVoucher) {
					let voucherGetUpdated = await updateVoucher(getVoucher.id, "USED");

					if (voucherGetUpdated) {
						this.showVoucherUpdateSuccess = true;
						this.showVoucherUpdateFailed = false;
						this.$emit("reload");
					} else {
						this.showVoucherUpdateFailed = true;
						this.showVoucherUpdateSuccess = false;
					}
				} else {
					this.showVocherCodeNotValid = true;
				}
			} else {
				this.voucherCodeMissing = true;
			}
		},
		clickCloseButton() {
			this.$emit("reload");
		},
	},
};
</script>

<template>
	<!-- Delete Dataset Model -->
	<b-modal
		v-model="showModal"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
		no-close-on-esc
		header-close-content
	>
		<div v-if="this.isVoucherValid" class="row mt-3 justify-content-center">
			<div class="col-md-12 text-center mb-4">
				<b-img
					class=""
					alt=""
					:src="require('@/assets/images/Voucher Valid.png')"
					style="height: 150px"
				></b-img>
			</div>
			<div class="col-md-10 text-center">
				<div class="mb-3">
					<h5 class="mb-3">
						<i class="bx bxs-check-circle bx-tada text-success"></i>
						{{ $t("vouchers.validity.voucherValidMsg") }}
					</h5>
					<p>
						{{ $t("vouchers.validity.voucherStatusChageText") }}
					</p>
				</div>
				<div class="pt-3">
					<b-alert v-model="showVocherCodeNotValid" variant="danger" dismissible
						><i class="mdi mdi-check-all mr-2"></i
						>{{ $t("vouchers.validity.voucherCodeNotVaild") }}</b-alert
					>
					<b-alert v-model="showVoucherUpdateSuccess" variant="success"
						><i class="mdi mdi-check-all mr-2"></i
						>{{ $t("vouchers.validity.voucherUpdatedSuccessfully") }}</b-alert
					>
					<b-alert
						v-model="showVoucherUpdateFailed"
						variant="danger"
						dismissible
						><i class="bx bx-error-circle mr-2"></i
						>{{ $t("vouchers.validity.voucherUpdatedFailed") }}</b-alert
					>
					<b-form-group v-if="!showVoucherUpdateSuccess">
						<b-form-input
							v-model="voucherCodeToUpdate"
							:placeholder="this.$i18n.t('vouchers.validity.placeholder')"
						></b-form-input>
						<small v-if="this.voucherCodeMissing" class="text-danger">{{
							$t("vouchers.validity.vocuherCodeMissing")
						}}</small>
					</b-form-group>
				</div>
				<div class="pt-3 pb-2">
					<b-button
						v-if="!showVoucherUpdateSuccess"
						class="mr-3"
						variant="warning"
						@click="clickUpdateVoucherStatus()"
						>{{ $t("vouchers.validity.voucherUpdateButton") }}</b-button
					>
					<b-button variant="light" @click="showModal = false">{{
						$t("general.buttons.cancel")
					}}</b-button>
				</div>
			</div>
		</div>
		<div v-if="!this.isVoucherValid" lass="row mt-3">
			<div class="col-md-12 text-center mb-4">
				<b-img
					class=""
					alt=""
					:src="require('@/assets/images/Voucher Not Valid.png')"
					style="height: 150px"
				></b-img>
			</div>
			<div class="col-md-12 text-center">
				<div class="mb-3">
					<h5 class="mb-3">
						<i class="bx bxs-error bx-tada text-danger"></i>
						{{ $t("vouchers.validity.voucherNotValidMsg") }}
					</h5>
					<p v-if="this.voucherCurrentStatus === 'USED'">
						{{ $t("vouchers.validity.voucherUsedErrorMsg") }}
					</p>
					<p v-if="this.voucherCurrentStatus === 'NOTACTIVE'">
						{{ $t("vouchers.validity.voucherNotActivatedErrorMsg") }}
					</p>
					<p
						v-if="
							this.voucherCurrentStatus === 'CLOSED' ||
								this.voucherCurrentStatus === 'NOTVALID'
						"
					>
						{{ $t("vouchers.validity.voucherNotValidErrorMsg") }}
					</p>
				</div>
				<div class="pt-3 pb-2">
					<b-button variant="light" @click="clickCloseButton()">{{
						$t("general.buttons.cancel")
					}}</b-button>
				</div>
			</div>
		</div>
	</b-modal>
</template>
